'use client';

import FormInput, { InputProps } from '@/components/Form/FormInput';
import { formErrorKeyMap, formatZipCode, removeEmoji } from '@/utils/form-rule';
import { useTranslations } from 'next-intl';
import React from 'react';

// ZipCodeInput组件的属性，继承自FormInput的属性
export type ZipCodeInputProps = Omit<InputProps, 'formatInput'> & {
  countryId: string;
};

const ZipCodeInput: React.FC<ZipCodeInputProps> = ({
  countryId,
  placeholder,
  label,
  slotProps,
  layout = 'inline',
  required = true,
  ...restProps
}) => {
  const t = useTranslations('components.address.validation');
  const tZipCode = useTranslations('components.form.zipCodeInput');

  // 格式化邮政编码
  const formatZipCodeInput = (value: string): string => {
    let newValue = removeEmoji(value.trim());

    // 美国邮编特殊处理
    if (countryId === 'US') {
      newValue = formatZipCode(newValue);
    }

    return newValue;
  };

  // 验证规则
  const zipCodeRules = {
    required: required ? t(formErrorKeyMap[14]) : false, // 14是邮政编码为空的错误码
    validate: (value: string) => {
      if (!required && (!value || value.trim() === '')) {
        return true;
      }

      // 验证美国邮政编码
      if (countryId === 'US' && !/^(?:\d{5})(?:-\d{4}|\d{4})?$/.test(value)) {
        return t(formErrorKeyMap[15]); // 美国邮政编码格式错误
      }

      return true;
    },
  };

  return (
    <FormInput
      label={label || tZipCode('label')}
      layout={layout}
      placeholder={placeholder || tZipCode('placeholder')}
      required={required}
      formatInput={formatZipCodeInput}
      rules={zipCodeRules}
      {...restProps}
      slotProps={{
        htmlInput: {
          maxLength: countryId === 'US' ? 10 : 20,
        },
        ...slotProps,
      }}
    />
  );
};

export default ZipCodeInput;
